// extracted by mini-css-extract-plugin
module.exports = {"name":"EmployeeRow_name__1ajSk","avatarContainer":"EmployeeRow_avatarContainer__XLC1e","checkboxContainer":"EmployeeRow_checkboxContainer__2vk93"};